export default __webpack_public_path__ + "ee9f4024d1ff565b32c968f75b52df84.svg";